import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ProductsContextProvider } from './context/ProductsContext';
import { CartProvider } from './context/CartContext';
import { AuthContextProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthContextProvider> 
       <ProductsContextProvider >
    <CartProvider>

    <App />
 
    </CartProvider>
    </ProductsContextProvider>
    </AuthContextProvider>
  </React.StrictMode>,

);
